import { render, staticRenderFns } from "./InboundStatisticsPopup.vue?vue&type=template&id=4a0c49ac&scoped=true&"
import script from "./InboundStatisticsPopup.vue?vue&type=script&lang=js&"
export * from "./InboundStatisticsPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0c49ac",
  null
  
)

export default component.exports